<div class="bp-container mod-padding">
  <div class="side-menu">
    <div main (click)="goBackToWallet()">
      <span class="bpi__icon-caret-left"></span>
      <span class="font-size-15 pl-15">{{ "wallet_details_back" | translate }}</span>
    </div>
  </div>
  <div class="content card">
    <h1 class="headline">{{ "wallet_details" | translate }}</h1>
    <bp-tile
      [isWalletDetails]="true"
      [title]="'deposit_address' | translate"
      id="deposit-address"
      #depositAddressTile>
      <div tile-actions>
        @if (isAtLeastDocumented) {
          <a class="wallet-download" (click)="downloadPdf()">
            {{ "download_as_pdf" | translate }}
          </a>
        }
      </div>
      <div tile-info>
        <bp-info>{{ "deposit_address_info" | translate }}</bp-info>
      </div>
      @if (isUnverified) {
        <empty
          [headline]="'please_verifiy_for_deposit_header' | translate"
          text="please_verifiy_for_deposit_text"
          buttonText="click_here_to_start_verification"
        (buttonClick)="startVerify()"></empty>
      }
      <!-- QR code -->
      @if (isAtLeastDocumented) {
        <sepa-qr
          [wallet]="wallet"
          [showNonEuInfo]="showNonEuInfo()"
        [provider]="getDefaultProvider()"></sepa-qr>
      }
    </bp-tile>
  </div>
</div>
